<template>
    <div>
        <p class="text-small text-primary font-weight-medium mb-3" v-if="showTitle">
            <v-icon class="me-2" color="secondary" size="20">icon-chart</v-icon>ارتباط محصولات و تیکت‌ها
        </p>
        <v-skeleton-loader v-if="skeleton" class="mx-auto" height="350" type="ossein"></v-skeleton-loader>
        <apexchart
            :options="chartOptions"
            :series="series"
            height="350"
            v-else
        ></apexchart>
    </div>
</template>
<script>
import fa from "apexcharts/dist/locales/fa.json";
import VueApexCharts from "vue3-apexcharts";
export default {
    components: {
        apexchart: VueApexCharts,
    },
    props: {
        showTitle: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            skeleton: true,
            series: [],
            chartOptions: {
                chart: {
                    locales: [fa],
                    defaultLocale: "fa",
                    stacked: true,
                    type: "bar",
                },
                plotOptions: {
                    bar: {
                        borderRadius: 10,
                        dataLabels: {
                            position: "top",
                        },
                    },
                },
                dataLabels: {
                    enabled: true,
                    offsetY: 0,
                    style: {
                        fontSize: "12px",
                        colors: ["#fff"],
                        fontFamily: "iransans",
                    },
                },
                tooltip: {
                    style: {
                        fontFamily: "iransans",
                    },
                    y: {
                        title: {
                            formatter: () => "تعداد تیکت:",
                        },
                    },
                },
                xaxis: {
                    categories: [],
                    labels: {
                        style: {
                            fontFamily: "iransans",
                        },
                    },
                    position: "bottom",
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    },
                    tooltip: {
                        enabled: false,
                    },
                },
                yaxis: {
                    labels: {
                        style: {
                            fontFamily: "iransans",
                        },
                    },
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    },
                },
            },
            search: [],
        };
    },
    methods: {
        reportServiceTicketFilter(search) {
            this.skeleton = true;
            this.search = { ...search };
            this.reportServiceTicketGet();
        },
        reportServiceTicketGet() {
            this.$reportServiceTicket(
                this.$route.path !== "/report"
                    ? { from_date: this.$moment().subtract(1, "years").unix() }
                    : this.search
            ).then((res) => {
                if (res && res.status == "OK") {
                    this.series = [];
                    this.chartOptions.xaxis.categories = [];
                    res.data = res.data.filter((x) => x.total);
                    this.chartOptions.xaxis.categories.push(
                        ...res.data.map((item) => item.x)
                    );
                    this.series.push({
                        data: [...res.data.map((item) => item.total)],
                    });
                    this.skeleton = false;
                }
            });
        },
    },
    mounted() {
        this.reportServiceTicketGet();
    },
};
</script>
